import { Box, Typography } from '@mui/material'

import { helloMessage } from '../../services/constants'
import custom from '../../styles/mui/szVariables.json'

export default function HelloSunshine({ display }: any) {
    return (
        <Box display={display || 'flex'}
            justifyContent={"space-between"} 
            alignItems={"flex-start"} 
            flexDirection={"column"}
            width="500px">
            <Box 
                mt={custom.spacing.xl}
                ml={custom.spacing.md}
                component={"img"}           
                height={custom.sizes.xxl}
                loading="lazy"
                alt="Solar Zero Logo"
                src="/images/szNamedLogoWhite.svg" />
            <Box ml={custom.spacing.md}
                 mt={custom.spacing.sm}
                 mb={custom.spacing.md} >
                <Box
                    component={"img"}           
                    height="102px"
                    width="273px"
                    loading="lazy"
                    alt="Hello Sunshine"
                    src="/images/HelloSunshineYellow.svg" />
                <Typography color="#FFF"
                    component={"p"}
                    mt={custom.spacing.md}
                    mr={custom.spacing.xs}
                    variant="szBody.Regular.Large">
                    {helloMessage}
                </Typography>
            </Box>
        </Box>
    )
}